import Emitter from "./Emitter";

export default class CloseHelp extends Emitter {
    constructor(gb) {
        super(gb);
    }

    LNWOGS_handler() {
        this.gb.wallet.closeHelp();
    }

    _default() {
        return
    }
}
